module.exports = __webpack_public_path__ + "Leon Liu-cf62e86e.png";